module.exports = __webpack_public_path__ + "static/cogs-white-b0b6a2e6903bc955f1e525dce1ba784e.svg";